module.exports = __webpack_public_path__ + "static/media/22770631_1629542047120980_4067030076592498077_o.00b63fe4.jpg";